import {
    ConfigitAceVariableIntervalValue,
    ConfigitAceVariableSingletonValue,
    ConfigitAceVariableValue,
    ConfigitAceItem,
    ConfigitAceAssignedBy,
    ConfigitAceAssignment,
} from '../models/configit-ace.model';
import moment from 'moment/moment';
import { ConfigitAssignment } from '../components/questionnaire/configit-quest-adapter/configit-types.interface';
import { environment } from '../../../environments/environment';

const dateFormat = 'DD.MM.YYYY';

const MODEL_ACE_MAPPING = {
    Photovoltaics: 'QA-PHOTOVOLTAICS',
};

export function isAceModel(model: string) {
    return (
        environment.quest.ace &&
        (Object.keys(MODEL_ACE_MAPPING).includes(model) || Object.values(MODEL_ACE_MAPPING).includes(model))
    );
}

export function getAceForConfigitModel(model: string) {
    return MODEL_ACE_MAPPING[model];
}

export function getAssignmentValue(variableId: string, assignments: ConfigitAceAssignment[]) {
    return assignments?.find((a) => a.variableId === variableId)?.value || '';
}

export function isUserAssignment(assignment: ConfigitAceAssignment) {
    return assignment.assignedBy === ConfigitAceAssignedBy.user;
}

export function userAssignments(assignments: ConfigitAceAssignment[]) {
    return assignments.filter(isUserAssignment);
}

export function fromBooleanString(value: string) {
    return value?.toLowerCase() === 'true';
}

export function fromConfigitAssignments(assignments: ConfigitAssignment[]): ConfigitAceAssignment[] {
    return assignments.map((a) => ({
        instanceId: 'ROOT',
        variableId: a.variableName,
        assignedBy: a.isUserAssignment ? ConfigitAceAssignedBy.user : ConfigitAceAssignedBy.system,
        value: a.valueName,
    }));
}

export function getProperty(id: string, item: ConfigitAceItem) {
    return item.properties.find((p) => p.id === id)?.value;
}

export function isVisible(item: ConfigitAceItem): boolean {
    return getProperty('SHOW', item) === true;
}

export function singletonValues(values: ConfigitAceVariableValue[]) {
    return <ConfigitAceVariableSingletonValue[]>values.filter((v) => v.type === 'SingletonValue');
}

export function intervalValues(values: ConfigitAceVariableValue[]) {
    return <ConfigitAceVariableIntervalValue[]>values.filter((v) => v.type === 'IntervalValue');
}

export function toIsoDate(value: string): string {
    if (value) {
        const parsed = moment(value, dateFormat).utcOffset(0, true);
        return parsed?.toISOString();
    }
    return '';
}
export function fromIsoDate(value: string) {
    const date = moment(value);
    return date?.format(dateFormat);
}
